import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import NavTabs from '../Tabs';
import {
  ADMIN_ANALYTICS_WASTE_CADASTRE_PAGE,
  ADMIN_ANALYTICS_WASTE_CADASTRE_DOCS,
  ADMIN_ANALYTICS_WASTE_CADASTRE_ANALYTICS,
} from "../../constants/routes";

export default function AnalyticsWasteCadastreToolbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const tabs = [
    {
      name: ADMIN_ANALYTICS_WASTE_CADASTRE_DOCS,
      label: 'Аналитические отчеты (Электронный документооборот)',
      nowrapTab: true,
    },
    {
      name: ADMIN_ANALYTICS_WASTE_CADASTRE_ANALYTICS,
      label: 'Аналитика кадастра отходов',
      nowrapTab: true,
    },
  ];

  const currentTab = tabs.find(tab => pathname.includes(tab.name))?.name || tabs[0].name;

  const changeTab = (newTab) => {
    navigate(newTab);
  };

  if (!pathname.includes(`${ADMIN_ANALYTICS_WASTE_CADASTRE_PAGE}`)) return null;

  return (
    <Box display="flex" alignItems="flex-end" minHeight="64px">
      <NavTabs tabsComponents={tabs} setTab={changeTab} tab={currentTab} />
    </Box>
  );
}
